import React from "react";
import { AnimateIn, StaggerIn } from "./AnimateIn";
import "./Team.css";

export const Team = ({ data }) => {
  if (!data) return null;

  return (
    <section id="team" className="team-section">
      <div className="section-container">
        <AnimateIn variant="fadeUp">
          <div className="team-header">
            <p className="eyebrow">{data.eyebrow}</p>
            <h2 className="section-title">{data.title}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>{data.subtitle}</p>
          </div>
        </AnimateIn>
        <StaggerIn variant="fadeUp" stagger={0.15} className="team-grid">
          {data.members.map((member, i) => (
            <div key={i} className="team-card">
              <div className="team-image-wrapper">
                <img src={member.img} alt={member.name} className="team-image" />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <span className="team-role">{member.job}</span>
                <p className="team-bio">{member.bio}</p>
                <div className="team-skills">
                  {member.skills.map((skill, j) => (
                    <span key={j} className="team-skill-tag">{skill}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </StaggerIn>
      </div>
    </section>
  );
};
